let $ = require("jquery");
let _ = require("underscore");
let DbRecorder = require("../recorder/DbRecorder.js");
import POS from "../POS.js";
import PrinterConverterUtil from "../utils/PrinterConverterUtil.js";
import CloudPrintUtils from "../service/CloudPrintUtils.js";
import TooieStatusService from "./TooieStatusService.js";
let Backbone = require("backbone");

let main = function () {
    var status = new Backbone.Model({
        lastHeartbeat: null,
        pluginConnected: false,
        printerDisconnected: false,
        printers: [],
        errors: {},
        queueCount: 0,
        offline:false
    });
    var CLOUD_HEARTBEAT_INTERVAL = 1000 * 10;

    var PrintService = {

        _initialize: function () {
            this._pollPrinterStatus();
        },

        _getChromeAppId: function () {
            return DbRecorder.read("chromeAppId");
        },

        _getAndroidPrinterSettings: function () {
            return DbRecorder.read("networkPrinterSetting") || [];
        },

        // 云打印方法
        _cloudPrint: function (payload, billId) {
            if (!POS.getUseCloudPrint()) {
                return;
            }
            $.post("/pos/print", {
                payload: JSON.stringify(payload),
                restaurantId: POS.getRestaurant().id,
                billId: billId
            }).fail(function (response, xhr) {
                //Raven.captureMessage("cloud error", {extra: {payload: payload}});
                console.warn(new Date() + " unable to relay print request to cloud print server: ", xhr.status);
                TooieStatusService.statusModel().set({'status': 'PrintError'});
            });
        },

        _chromePrint: function (data) {
            if (POS.getUseCloudPrint()) {
                return;
            }
            if (typeof(chrome) !== 'undefined' && chrome.runtime && chrome.runtime.sendMessage) {
                chrome.runtime.sendMessage(this._getChromeAppId(), {msg: data});
            }
        },

        _recordBillPrintCount: function (bill, printType) {
            let jxhr, self = this;
            jxhr = $.post("/pos/recordPrintCount", {billId: bill.id, printType: printType});
            jxhr.done(function (res) {
                console.log("success");
            });
            jxhr.fail(function (res) {
                DbRecorder.recordPrintQueue(bill, printType)
            });
        },

        _pollChromePrinterStatus: function () {
            if (typeof(chrome) !== 'undefined' && chrome.runtime && chrome.runtime.sendMessage) {
                chrome.runtime.sendMessage(this._getChromeAppId(), {msg: "checkStatus"}, _.bind(function (data) {
                    if (typeof(data) == 'undefined') {
                        status.set({pluginConnected: false});
                    } else {
                        status.set({printers: data.printerList});
                        var hasError = _(data.printerList).any(function (printer) {
                            return !printer.online;
                        });
                        if (!status.get("pluginConnected")) {
                            // plugin becomes connected
                            var port = chrome.runtime.connect(this._getChromeAppId());
                            port.onMessage.addListener(function (msg) {
                                if (msg.event == 'connected') {
                                    status.set({pluginConnected: true});
                                } else if (msg.event == 'print-error') {
                                    var errorCount = status.get('errors')[msg.printer];
                                    errorCount = (isNaN(errorCount) ? 0 : errorCount) + 1;
                                    var newData = {};
                                    newData[msg.printer] = errorCount;
                                    status.set({errors: _.extend(status.get('errors'), newData)});
                                    status.trigger('change');
                                    $.post("/pos/chromePrintError", {
                                        restaurantId: POS.getRestaurant().id,
                                        type: msg.data.type,
                                        billSid: msg.data.bill,
                                        printName: msg.printer
                                    })
                                }
                            });
                            port.onDisconnect.addListener(function () {
                                status.set({pluginConnected: false});
                            });
                        }
                        status.set({pluginConnected: true, printerDisconnected: hasError});
                    }
                    _.delay(_.bind(this._pollChromePrinterStatus, this), 5 * 1000);
                }, this));
            }
        },

        _pollCloudPrinterStatus: function () {
            if (POS.getUseCloudPrint()) {
                if (!status.get("lastHeartbeat") || status.get("lastHeartbeat").getTime() < (new Date().getTime() - CLOUD_HEARTBEAT_INTERVAL)) {
                    status.set({pluginConnected: false, printers: [], errors: []});
                } else {
                    status.set({pluginConnected: true});
                }
                _.delay(_.bind(this._pollCloudPrinterStatus, this), CLOUD_HEARTBEAT_INTERVAL);
            }
        },

        _pollPrinterStatus: function () {
            if (POS.getUseCloudPrint()) {
                this._pollCloudPrinterStatus();
            } else {
                this._pollChromePrinterStatus();
            }
        },

        printBusinessRecords: function (bills, params) {
            console.log(new Date() + " printing business records", bills, params);
            var data = PrinterConverterUtil.toBusinessRecord(bills, params);
            CloudPrintUtils._cloudPrint({
                type: "BusinessRecord",
                data: data
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "BusinessRecord") {
                                var bytes = PrinterUtil.formatForAndroid(data.data, {width: printer.width, margin: 3});
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var bytes = PrinterUtil.formatForAndroid(data.data, {width: 48, margin: 1});
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(data);
        },

        // 营业统计（包含菜类，总数据）
        printBusinessStatistics: function (response, params) {
            console.log(new Date() + " printing business records", response, params);
            var data = PrinterConverterUtil.toBusinessStatistics(response, params);
            console.log(new Date() + " printing records data:", data);
            // 直接调用打印接口服务
            this._cloudPrint({
                type: "BusinessRecord",
                data: data
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "BusinessRecord") {
                                var bytes = PrinterUtil.formatForAndroid(data.data, {width: printer.width, margin: 3});
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(data);
        },

        printMembershipCredit: function (creditItem, status) {
            var data = PrinterConverterUtil.toMembershipReceipt(creditItem, status);
            CloudPrintUtils._cloudPrint({
                type: "Receipt",
                data: data
            });
            if (window.AndroidClient) {
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(data);
        },

        printMembershipInfoReceipt: function (billDetail) {
            console.log(new Date() + " printing membership info receipt", billDetail);
            var data, creditItem = null, self = this;
            if (billDetail) {
                var result = $.post('/membership/searchCredit', {id: billDetail.id});
                result.done(function (res) {
                    if (res.success) {
                        creditItem = res.creditItem;
                    }
                    if (creditItem) {
                        data = PrinterConverterUtil.toMembershipReceipt(creditItem);
                        self._chromePrint(data);
                        self._cloudPrint({
                            type: "Receipt",
                            data: data
                        });
                    }
                });
            }
            // if (window.AndroidClient) {
            //    var printerSetting = this._getAndroidPrinterSettings();
            //    if (printerSetting.length > 0) {
            //        _.each(printerSetting, function (printer) {
            //            _.each(printer.types, function (type) {
            //                if (type == "Receipt") {
            //                    bytes = PrinterUtil.formatForAndroid(data.data, {
            //                        width: printer.width,
            //                        margin: 3
            //                    });
            //                    window.AndroidClient.print(bytes, printer.ip);
            //                }
            //            });
            //        });
            //    }
            //    if (window.AndroidClient.printOnWoyouPosPrinter) {
            //        var bytes = PrinterUtil.formatForAndroid(data.data, {width: 32, margin: 1});
            //        window.AndroidClient.printOnWoyouPosPrinter(bytes);
            //    }
            // }
        },

        printCashierReceipt: function (billDetail, type) {
            console.log(new Date() + " printing cashier receipt", billDetail);
            var data = PrinterConverterUtil.toCashierReceipt(billDetail, type);
            data.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            CloudPrintUtils._cloudPrint({
                type: "Receipt",
                data: data,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "Receipt") {
                                bytes = PrinterUtil.formatForAndroid(data.data, {
                                    width: printer.width,
                                    margin: 3
                                });
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(data);
        },

        openCashbox: function () {
            console.log(new Date() + " opening cashbox");
            var data = PrinterConverterUtil.openCashBox();
            CloudPrintUtils._cloudPrint({
                type: "Map",
                data: data
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == 'Map') {
                                window.AndroidClient.print([27, 64, 27, 112, 0, 64, 240], printer.ip);
                            }
                        });
                    });
                }
                // if (window.AndroidClient.printOnWoyouPosPrinter) {
                //     window.AndroidClient.printOnWoyouPosPrinter([27,112,0,10,10],null,null);
                //     window.AndroidClient.printOnWoyouPosPrinter([27,112,1,10,10],null,null);
                // }
            }
            this._chromePrint(data);
        },

        printQrCode: function (image) {
            console.log(new Date() + " printing QR code");
            var data = PrinterConverterUtil.printQrcode(image);
            CloudPrintUtils._cloudPrint({
                type: "QRCode",
                data: data
            });
            this._chromePrint(data);
        },


        printAndroidDeviceDispatch: function (billDetail, type, flag) {
            var result = PrinterConverterUtil.toDispatchReceipt(billDetail, "dispatch", true);
            var printerSetting = this._getAndroidPrinterSettings();
            if (window.AndroidClient) {
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "DisPatch") {
                                var bytes = PrinterUtil.formatForAndroid(result.data, {
                                    width: printer.width,
                                    margin: 3,
                                    tagsAll: true,
                                    tags: printer.tags

                                });
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
            }
        },
        printAndroidDeviceItems: function (billDetail, type, flag) {
            var result = PrinterConverterUtil.toEachItemReceipts(billDetail, type, flag);
            var printerSetting = this._getAndroidPrinterSettings();
            if (window.AndroidClient) {
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "EachItem") {
                                _.each(result, function (data) {
                                    var contained = true;
                                    if (data.tags && data.tags.length > 0 && printer.tags && printer.tags.length > 0) {
                                        contained = _.any(printer.tags, function (it) {
                                            return _.any(data.tags, function (tag) {
                                                return tag == it;
                                            });
                                        });
                                    } else if ((data.tags && data.tags.length > 0) || (printer.tags && printer.tags.length > 0)) {
                                        contained = false;
                                    } else {
                                        contained = true
                                    }
                                    if (contained) {
                                        var bytes = PrinterUtil.formatForAndroid(data.data, {
                                            width: printer.width,
                                            margin: 3
                                        });
                                        window.AndroidClient.print(bytes, printer.ip);
                                    }
                                });
                            }
                        });
                    });
                }
            }
        },
        // 收据打印 对账单
        printOrderReceipt: function (billDetail, flag, type) {
            var isWoyou = (window.AndroidClient && window.AndroidClient.printOnWoyouPosPrinter);
            console.log(new Date() + " printing order receipt", billDetail, flag);
            var result = PrinterConverterUtil.toOrderReceipt(billDetail, flag, isWoyou, type);
            // bill对应的一个标识
            result.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            // 调用云打印的接口12121
            console.log( "printing order toOrderReceip:",result);
            CloudPrintUtils._cloudPrint({
                type: "Statement",
                data: result,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "Statement") {
                                var bytes = PrinterUtil.formatForAndroid(result.data, {
                                    width: printer.width,
                                    margin: 3
                                });
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var cutPaper = (billDetail.qrcode && billDetail.qrcode.length > 0);
                    var bytes = PrinterUtil.formatForAndroid(result.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    }, cutPaper);
                    if (billDetail.qrcode && billDetail.qrcode.length > 0) {
                        window.AndroidClient.printOnWoyouPosPrinter(bytes, billDetail.qrcode[0].url, billDetail.qrcode[1].url);
                    } else {
                        window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                    }
                }
            }
            this._chromePrint(result);
        },



        printDispatchReceipt: function (billDetail, type, flag) {
            console.log(new Date() + " printing dispatch receipt", billDetail, type, flag);
            var result = PrinterConverterUtil.toDispatchReceipt(billDetail, "dispatch", flag);
            result.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            CloudPrintUtils._cloudPrint({
                type: "DisPatch",
                data: result,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            }, billDetail.id);
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "DisPatch") {
                                var bytes = PrinterUtil.formatForAndroid(result.data, {
                                    width: printer.width,
                                    margin: 3,
                                    tagsAll: true,
                                    tags: printer.tags
                                });
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    if (androidDevice == "v1") {
                        var bytes = PrinterUtil.formatForAndroid(result.data, {width: 32, margin: 1});
                        window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                    }
                }
            }
            this._chromePrint(result);
        },

        printRedispatchReceipt: function (billDetail, rePrint) {
            console.log(new Date() + " printing re-dispatch receipt", billDetail);
            var result = PrinterConverterUtil.toDispatchReceipt(billDetail, "ReDisPatch", null, rePrint);
            result.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            CloudPrintUtils._cloudPrint({
                type: "DisPatch",
                data: result,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            }, billDetail.id);
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "DisPatch") {
                                var bytes = PrinterUtil.formatForAndroid(result.data, {
                                    width: printer.width,
                                    margin: 3,
                                    tagsAll: true,
                                    tags: printer.tags
                                });
                                window.AndroidClient.print(bytes, printer.ip);
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(result.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(result);
        },

        printItemReceipts: function (billDetail, billItem, type,refundQuantity) {
            console.log(new Date() + " printing item receipts", billDetail, billItem, type);
            var printerSetting = this._getAndroidPrinterSettings();
            var result = PrinterConverterUtil.toEachItemReceipt(billDetail, billItem, type == "Refund" ? "RefundItem" : (type == "ReEachItem" ? "ReEachItem" : "EachItem"),null,null,refundQuantity);
            result.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            CloudPrintUtils._cloudPrint({
                type: type == "Refund" ? "RefundItem" : "EachItem",
                data: result,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            });
            if (window.AndroidClient) {
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (printType) {
                            type = type == "Refund" ? "RefundItem" : "EachItem";
                            var contained = true;
                            if (result.tags && result.tags.length > 0 && printer.tags && printer.tags.length > 0) {
                                contained = _.any(printer.tags, function (it) {
                                    return _.any(result.tags, function (tag) {
                                        return tag == it;
                                    });
                                });
                            } else {
                                contained = true;
                            }
                            if (contained) {
                                if (printType == type) {
                                    var bytes = PrinterUtil.formatForAndroid(result.data, {
                                        width: printer.width,
                                        margin: 3
                                    });
                                    window.AndroidClient.print(bytes, printer.ip);
                                }
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(result.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
            this._chromePrint(result);
        },

        printItemsReceipts: function (billDetail, type, flag, rePrint) {
            console.log(new Date() + " printing items receipts", billDetail, type, flag);
            var result = PrinterConverterUtil.toEachItemReceipts(billDetail, type, flag, rePrint);
            // CloudPrintUtils._cloudPrint({
            //     type: "EachItem",
            //     data: result,
            //     bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            // });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "EachItem") {
                                _.each(result, function (data) {
                                    var contained = true;
                                    if (data.tags && data.tags.length > 0 && printer.tags && printer.tags.length > 0) {
                                        contained = _.any(printer.tags, function (it) {
                                            return _.any(data.tags, function (tag) {
                                                return tag == it;
                                            });
                                        });
                                    } else {
                                        contained = true;
                                    }
                                    if (contained) {
                                        var bytes = PrinterUtil.formatForAndroid(data.data, {
                                            width: printer.width,
                                            margin: 3
                                        });
                                        window.AndroidClient.print(bytes, printer.ip);
                                    }
                                });
                            }
                        });
                    });
                }

                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    if (POS.getRestaurant().get('sendBillFlag') || androidDevice == "v1" || androidDevice == "t1") {
                        _.each(result, function (data) {
                            var bytes = PrinterUtil.formatForAndroid(data.data, {
                                width: androidDevice == "v1" ? 32 : 48,
                                margin: 1
                            });
                            window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                        });
                    }
                }
            }
            this._chromePrint(result);
        },

        printTagReceipts: function (billDetail, type, flag) {
            console.log(new Date() + " printing tag receipts", billDetail, type, flag);
            var result = PrinterConverterUtil.toTagReceipts(billDetail, type, flag);
            CloudPrintUtils._cloudPrint({
                type: "TagItem",
                data: result
            });
            if (window.AndroidClient) {
                var printerSetting = this._getAndroidPrinterSettings();
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "TagItem") {
                                _.each(result, function (data) {
                                    var contained = true;
                                    if (data.tags && data.tags.length > 0 && printer.tags && printer.tags.length > 0) {
                                        contained = _.any(printer.tags, function (it) {
                                            return _.any(data.tags, function (tag) {
                                                return tag == it;
                                            });
                                        });
                                    } else {
                                        contained = true;
                                    }
                                    if (contained) {
                                        var bytes = PrinterUtil.formatTag(data.data,
                                            {
                                                width: printer.tagWidth,
                                                height: printer.tagHeight,
                                                gap: printer.tagGap,
                                                autoPeel: printer.autoPeel
                                            });
                                        window.AndroidClient.print(bytes, printer.ip);
                                    }
                                });
                            }
                        });
                    });
                }
            }
            this._chromePrint(result);
        },

        printCancelledItemReceipts: function (billDetail, rePrint) {
            console.log(new Date() + " printing cancelled item receipts", billDetail);
            var printerSetting = this._getAndroidPrinterSettings();
            var items = PrinterConverterUtil.toEachItemReceipts(billDetail, "RefundItem", null, rePrint);
            if (window.AndroidClient) {
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "RefundItem") {
                                _.each(items, function (data) {
                                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                                        width: printer.width,
                                        margin: 3
                                    });
                                    window.AndroidClient.print(bytes, printer.ip);
                                });
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    _.each(items, function (data) {
                        var bytes = PrinterUtil.formatForAndroid(data.data, {
                            width: androidDevice == "v1" ? 32 : 48,
                            margin: 1
                        });
                        window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                    });
                }
            }
            this._chromePrint(items);
        },

        printRefundedItemReceipts: function (billDetail, rePrint) {
            console.log(new Date() + " printing refunded item receipts", billDetail);
            var printerSetting = this._getAndroidPrinterSettings();
            var items = PrinterConverterUtil.toEachItemReceipts(billDetail, "RefundAmount", null, rePrint);
            if (window.AndroidClient) {
                if (printerSetting.length > 0) {
                    _.each(printerSetting, function (printer) {
                        _.each(printer.types, function (type) {
                            if (type == "RefundItem") {
                                _.each(items, function (data) {
                                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                                        width: printer.width,
                                        margin: 3
                                    });
                                    window.AndroidClient.print(bytes, printer.ip);
                                });
                            }
                        });
                    });
                }
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    _.each(items, function (data) {
                        var bytes = PrinterUtil.formatForAndroid(data.data, {
                            width: androidDevice == "v1" ? 32 : 48,
                            margin: 1
                        });
                        window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                    });
                }
            }
            this._chromePrint(items);
        },

        printMembershipTopupReceipt: function (membership, before, time) {
            console.log(new Date() + " printing member top-up receipt", membership, before, time);
            var data = PrinterConverterUtil.toMembershipReceipt(membership, before, {timeStr: time});
            CloudPrintUtils._cloudPrint({
                type: "Map",
                data: data
            });
            this._chromePrint(data);
        },
        printSwitchBillReceipt: function (billItem) {
            console.log(new Date() + " printing switch billitem receipt", billItem);
            var data = PrinterConverterUtil.toSwitchItemReceipt(billItem);
            console.log("printing switch billitem result", data);
            this._cloudPrint({
                type: "Map",
                data: data
            });
            this._chromePrint(data);
            if (window.AndroidClient) {
                if (window.AndroidClient.printOnWoyouPosPrinter && window.AndroidClient.printOnWoyouPosPrinter) {
                    var bytes = PrinterUtil.formatForAndroid(data.data, {width: 48, margin: 1});
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
        },

        printSwitchTableReceipt: function (billDetail) {
            console.log(new Date() + " printing switch table receipt", billDetail);
            var data = PrinterConverterUtil.toSwitchTableReceipt(billDetail);
            data.bill = billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID;
            CloudPrintUtils._cloudPrint({
                type: "Map",
                data: data,
                bill: billDetail.sid ? billDetail.sid + "(" + billDetail.shortUUID + ")" : billDetail.shortUUID
            });
            this._chromePrint(data);
            if (window.AndroidClient) {
                if (window.AndroidClient.printOnWoyouPosPrinter) {
                    var androidDevice = POS.getPrinterSetting().get("androidDevice");
                    var bytes = PrinterUtil.formatForAndroid(data.data, {
                        width: androidDevice == "v1" ? 32 : 48,
                        margin: 1
                    });
                    window.AndroidClient.printOnWoyouPosPrinter(bytes, null, null);
                }
            }
        },

        getPrinterStatus: function () {
            return status;
        },

        logCloudPrintError: function (error) {
            console.log("print error", error);
            //Raven.captureMessage("printer print message error", {extra: {printerName: error.printer.name,
            //error:error}});
            var errorCount = status.get('errors')[error.printer.name];
            errorCount = (isNaN(errorCount) ? 0 : errorCount) + 1;
            var newData = {};
            newData[error.printer.name] = errorCount;
            status.set({errors: _.extend(status.get('errors'), newData)});
            status.trigger('change');
        },

        logCloudPrinterStatus: function (statuses) {
            var hasError = _(statuses.printers).any(function (p) {
                return !p.online
            });
            status.set({
                printers: _(statuses.printers).map(function (p) {
                    return {
                        info: p.printer,
                        online: p.online,
                        name: p.printer.name,
                        type: p.printer.type
                    }
                }), pluginConnected: true,
                printerDisconnected: hasError,
                lastHeartbeat: new Date()
            });
        },

        logCloudPrinterQueueEvent: function(data) {
            status.set({queueCount: data.queueCount});
        },

    };
    PrintService.initialize = _.once(PrintService._initialize);
    return PrintService;
};
let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/service/PrintService.js